import { useEffect, useState } from 'react';

const PULSE_EFFECT_TIMEOUT_MS = 5000;
const PULSE_ANIMATION_DURATION_MS = 2000;

export const usePulseAnimations = ({
  showPulseEffect,
}: {
  showPulseEffect: boolean;
}) => {
  const [isPulseActive, setIsPulseActive] = useState(false);

  useEffect(() => {
    if (showPulseEffect) {
      setIsPulseActive(true);
      // Calculate timeout to end at the completion of an animation cycle
      // This ensures the animation stops smoothly at the end of a cycle
      const cyclesElapsed = Math.floor(
        PULSE_EFFECT_TIMEOUT_MS / PULSE_ANIMATION_DURATION_MS,
      );
      const nextCycleEnd = (cyclesElapsed + 1) * PULSE_ANIMATION_DURATION_MS;

      const timeout = setTimeout(() => {
        setIsPulseActive(false);
      }, nextCycleEnd);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      setIsPulseActive(false);
    }
  }, [showPulseEffect]);

  return {
    isPulseActive,
  };
};
